export default {
    servicosPlano: [],
    servicosPlanoPeriodos: [],
    servicoPlano: {},
    ultimaAtualizacaoListaServicoPlano: Date
}